import React, { useState, useEffect } from "react";
import styles from "./StatProspect.module.sass";
import cn from "classnames";
import Card from "../../../components/Card";
import Icon from "../../../components/Icon";
import { PieChart, Pie, Tooltip, Cell, ResponsiveContainer } from "recharts";
import { getProspectStatus } from "../../../services/dashboard.service"; 

const defaultData = [
  { name: "Nouveau", value: 0 },
  { name: "En cours", value: 0 },
  { name: "Success", value: 0 },
];
const COLORS = ["#B5E4CA", "#FFCC5C", "#2A85FF"];

const StatProspect = ({ className }) => {
  const [loading, setLoading] = useState(true);
  const [prospectData, setProspectData] = useState(defaultData);
  const [percentages, setPercentages] = useState([
    { title: "Nouveau", percent: 0, fill: "#B5E4CA" }, 
    { title: "En cours", percent: 0, fill: "#FFCC5C" },
    { title: "Success", percent: 0, fill: "#2A85FF" },
  ]);
  
  useEffect(() => {
    const fetchStatus = async () => { 
      try {
        setLoading(true);
        const data = await getProspectStatus(); 
        if (data && data.length > 0) {
          setProspectData(data);
          
          const total = data.reduce((sum, item) => sum + item.value, 0);
          if (total > 0) {
            const updatedPercentages = percentages.map(pItem => {
              const dataItem = data.find(d => d.name === pItem.title);
              const value = dataItem ? dataItem.value : 0;
              const percent = Math.round((value / total) * 100);
              return { ...pItem, percent }; 
            });
            setPercentages(updatedPercentages);
          } else {
            setPercentages(percentages.map(p => ({ ...p, percent: 0 })));
          }
        } else {
           setProspectData(defaultData);
           setPercentages(percentages.map(p => ({ ...p, percent: 0 })));
        }
      } catch (error) {
        console.error('Erreur lors de la récupération des statistiques de prospects:', error);
        setProspectData(defaultData); 
        setPercentages(percentages.map(p => ({ ...p, percent: 0 }))); 
      } finally {
        setLoading(false);
      }
    };
    
    fetchStatus(); 
  }, []); 

  return (
    <Card
      className={cn(styles.card, className)}
      title="Statut des prospects"
      classTitle="title-yellow"
    >
      <div className={styles.chart}>
        <ResponsiveContainer width="100%" height="100%">
          <PieChart width={400} height={400}>
            <Tooltip
              contentStyle={{
                backgroundColor: "#272B30",
                borderColor: "rgba(255, 255, 255, 0.12)",
                borderRadius: 8,
                boxShadow:
                  "0px 4px 8px rgba(0, 0, 0, 0.1), 0px 2px 4px rgba(0, 0, 0, 0.1), inset 0px 0px 1px #000000",
              }}
              labelStyle={{ fontSize: 12, fontWeight: "500", color: "#fff" }}
              itemStyle={{
                padding: 0,
                textTransform: "capitalize",
                fontSize: 12,
                fontWeight: "600",
                color: "#fff",
              }}
              formatter={(value) => [`${value} prospects`, '']}
            />
            <Pie
              data={loading ? defaultData : prospectData}
              cx={140} 
              cy={110} 
              innerRadius={88}
              outerRadius={110}
              fill="#8884d8"
              paddingAngle={1}
              dataKey="value"
            >
              {(loading ? defaultData : prospectData).map((entry, index) => (
                <Cell
                  key={`cell-${index}`}
                  fill={COLORS[index % COLORS.length]}
                />
              ))}
            </Pie>
          </PieChart>
        </ResponsiveContainer>
      </div>
      <div className={styles.legend}>
        {percentages.map((x, index) => (
          <div className={styles.indicator} key={index}>
            <div className={styles.title} style={{ color: x.fill }}>{x.title}</div>
            <div className={styles.percent}>{x.percent}%</div>
          </div>
        ))}
      </div>
    </Card>
  );
};

export default StatProspect;
